import type { ChangeEvent } from "react";

import Button from "../../../shared/components/elements/Button";
import InputField from "../../../shared/components/elements/InputField";
import type { AuthMode } from "../types";

interface OtpStepProps {
    mode: AuthMode;
    otp: string;
    loading: boolean;
    onOtpChange: (value: string) => void;
    onSubmit: () => void;
    onBack: () => void;
}

// Step 2: the SMS code
const OtpStep = ({ mode, otp, loading, onOtpChange, onSubmit, onBack }: OtpStepProps) => {
    return (
        <>
            <InputField
                type="tel"
                title="کد تایید"
                value={otp}
                onChange={(e: ChangeEvent<HTMLInputElement>) => onOtpChange(e.target.value)}
            />

            <Button onClick={onSubmit} className="mt-5" disabled={loading}>
                <span>
                    {loading ? "در حال انجام..." : mode === "login" ? "ورود" : "ثبت نام"}
                </span>
            </Button>

            <Button className="mt-4 text-gray-500" onClick={onBack}>
                تغییر شماره تلفن
            </Button>
        </>
    );
};

export default OtpStep;